import { Footer } from '@/components/Footer'
import { Card } from '@/components/Card'
import { Heading } from '@/components/Heading'
import { useLocation } from 'react-router'
import { Header } from '@/components/HeaderHome'
import { ReactSVG } from 'react-svg'
import { useContext, useEffect } from 'react'
import { DealerContext } from '@/context/DealerContext'
import PersistedLink from '@/components/PersistedLink'
import useFormContext from '@/context/useFormContext'
import { setPageMetadata } from '@/utils/seo'

function HomePage() {
  const location = useLocation()
  const currentParams = location.search
  const dealerContext = useContext(DealerContext)
  const isDealer = dealerContext?.isDealer ?? false
  const { dispatch } = useFormContext()

  useEffect(() => {
    setPageMetadata({
      title: 'UDC Finance | Application Selection Page',
    })
  }, [])

  useEffect(() => {
    // We need to attach required dealer details to the form context
    if (dealerContext?.dealerInformation.dealerId || dealerContext?.dealerInformation.dealerUniqueIdentifier) {
      dispatch({
        type: 'UPDATE_DEALER_DETAILS',
        payload: {
          dealerId: dealerContext?.dealerInformation.dealerId ?? null,
          dealerUniqueIdentifier: dealerContext?.dealerInformation.dealerUniqueIdentifier ?? null
        }
      })
    }
  }, [dealerContext?.dealerInformation.dealerId, dealerContext?.dealerInformation.dealerUniqueIdentifier, dispatch])
  
  return (
    <>
      <Header />
      <section className='px-4 md:px-6 lg:px-10 pb-16 lg:pb-20 grow'>
        <Heading>How would you like to apply?</Heading>
        <div className='max-w-6xl mx-auto justify-center flex flex-col md:flex-row max-md:items-center gap-8'>
          <PersistedLink to={`/personal${currentParams}`} className='w-[220px] max-w-[220px] grow'>
            <Card title='As an individual'>
              <ReactSVG className='Card-svg size-[108px] flex items-center justify-center' src={dealerContext?.dealerThemeIcon?.individual || '/icons/start/personal.svg'} />
            </Card>
          </PersistedLink>
          <PersistedLink to={`/business${currentParams}`} className='w-[220px] max-w-[220px] grow'>
            <Card title='As a business'>
              <ReactSVG className='Card-svg size-[108px] flex items-center justify-center' src={dealerContext?.dealerThemeIcon?.business || '/icons/start/business.svg'} />
            </Card>
          </PersistedLink>
        </div>
      </section>
      {!isDealer && <Footer />}
    </>
  )
}

export default HomePage
